export default function truncateFileName(origFileName, maxLength = 30) {
  const minLength = 11;

  if (typeof origFileName === 'string' && maxLength > minLength) {
    const fileName = origFileName.trim();
    const { length } = fileName;
    const stringEnd = `...${fileName.substring(length - 7)}`;

    return length > maxLength
      ? fileName.substring(0, maxLength - stringEnd.length) + stringEnd
      : fileName;
  }

  return origFileName;
}
